import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
} from "@angular/common/http";
import { HashingHelperService } from "@core/utils/hashing.helper.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
	/**
	 *
	 */
	constructor(private hashingHelper: HashingHelperService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		
		const beniHatirla = sessionStorage.getItem("BeniHatirla") || "0";
		req = req.clone({
			setHeaders: {
				"X-Beni-Hatirla": beniHatirla,
			},
		});

		if (sessionStorage.getItem("a")) {
			let aktifKullaniciBilgisi = JSON.parse(
				this.hashingHelper.decrypt(sessionStorage.getItem("a"))
			);
			if (aktifKullaniciBilgisi && aktifKullaniciBilgisi.TOKEN) {
				if (req.headers.get("AUTH_TOKEN") == "1A2GIMU*5648j5")
					req = req.clone({
						headers: req.headers.set(
							"AUTH_TOKEN",
							"1A2GIMU*5648j5",
						),
					});
				else
					req = req.clone({
						headers: req.headers.set(
							"AUTH_TOKEN",
							aktifKullaniciBilgisi.TOKEN
						),
					});
			}
		}
		//Application/json headerinin otomatik eklenmemesi için gerekli olduğu yerlerde kullanılacak.
		if (req.headers.has("Anonymous")) {
			const newHeaders = req.headers.delete("Anonymous");
			const newRequest = req.clone({ headers: newHeaders });
			return next.handle(newRequest);
		} else if (!req.headers.has("Content-Type")) {
			req = req.clone({
				headers: req.headers.set("Content-Type", "application/json"),
			});
		}
		req = req.clone({
			headers: req.headers.set("Access-Control-Allow-Origin", "*")
			.set('Access-Control-Allow-Credentials','true')
			.set('Access-Control-Allow-Headers', 'Content-Type')
			.set('Access-Control-Allow-Methods', 'GET,PUT,POST,OPTIONS,DELETE'),
		});
		return next.handle(req);
	}
}
